<template>
  <div class="col-md-12">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          <slot name="1"></slot>
        </li>
        <li class="breadcrumb-item active w-25" aria-current="page">
          <slot name="2"></slot>
        </li>
      </ol>
    </nav>
  </div>
</template>
<script>
export default {
  name: "breadcrumb",
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/Breadcrumb.vue